export default "/images/logo-5.png?70251045c6a881385b1e1b3fb7e48189";